/* eslint-disable */

/** unique or primary key constraints on table "argo.material_note_status" */
export enum ArgoMaterialNoteStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  MaterialNoteStatusPkey = 'material_note_status_pkey'
}

export enum ArgoMaterialNoteStatusEnum {
  /** Comment */
  Comment = 'comment',
  /** Concern */
  Concern = 'concern',
  /** Resolved */
  Resolved = 'resolved'
}

/** select columns of table "argo.material_note_status" */
export enum ArgoMaterialNoteStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.material_note_status" */
export enum ArgoMaterialNoteStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

